import { Navigate, useLocation } from 'react-router-dom';

import { PageVersionSwitch } from '@/components/PageVersionSwitch';
import { AccountPage as LegacyAccountPage } from 'views/account/AccountPage';
import { PageSpinner } from 'widgets';

import { AccountPage } from './AccountPage';
import { ACCOUNT_PAGE_TABS, accountPageBase, matchAccountPageTab, useAccountPageView } from './useAccountPageView';

export const AccountPageRouter = () => {
    const location = useLocation();
    const { view, enabled, isPending, switchView } = useAccountPageView();
    if (isPending) return <PageSpinner />;

    const search = new URLSearchParams(location.search);
    if (search.has('view')) {
        search.delete('view');
        return (
            <Navigate
                to={{ pathname: location.pathname, search: search.toString(), hash: location.hash }}
                state={location.state}
                replace
            />
        );
    }

    const tab = matchAccountPageTab(location.pathname);
    const target = view === 'new' ? (tab?.routeValue ?? ACCOUNT_PAGE_TABS[0].value) : tab?.legacyValue;
    if (target && location.pathname !== `${accountPageBase(location.pathname)}/${target}`) {
        return (
            <Navigate
                to={{
                    pathname: `${accountPageBase(location.pathname)}/${target}`,
                    search: location.search,
                    hash: location.hash,
                }}
                replace
            />
        );
    }

    return (
        <div className="relative flex h-full w-full flex-col overflow-hidden">
            {enabled && <PageVersionSwitch isNew={view === 'new'} onSwitch={switchView} />}
            <div className="min-h-0 flex-1">{view === 'new' ? <AccountPage /> : <LegacyAccountPage />}</div>
        </div>
    );
};
